import './Markets.scss';
import { MARKET_TYPE } from '../../../constants/common';
import CountryFlagCard from '../../CountryFlagCard/CountryFlagCard';
import SuccessIcon from '../../../assets/images/Shape.png';
import { useTranslation } from "react-i18next";

interface Props {
  markets: any[];
  tooltipSupportingText: string;
  type: string;
  subtitle?: string;
  title?: string;
  groupTitle?: string;
}

const Markets = ({
  markets,
  tooltipSupportingText,
  type,
  subtitle,
  title,
  groupTitle
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="market">
      {title && (
        <div className="container-header">
          <h3>{title}</h3>
          <div
            className={`square ${type === MARKET_TYPE.supported ? 'green' : 'orange'
              }`}
          ></div>
        </div>
      )}
      {subtitle && (
        <div className="container-text">
          <img
            alt="success icon"
            aria-label={
              t('markets.success')
            }
            className="icon-success"
            src={SuccessIcon}
          ></img>
          <span className="label-text">{subtitle}</span>
        </div>
      )}
      <div
        className="container container--markets"
        role="list"
        aria-label={
          [groupTitle || title, subtitle].filter(Boolean).join(', ') ||
          undefined
        }
      >
        {markets.map((m, i) => {
          const key = `${type}Market-${i}`;
          return (
            <div key={key}
            role="listitem"
            aria-label={m.name}
            tabIndex={0}
            style={{outline:'none'}}>
            <CountryFlagCard
              key={key}
              code={m.code}
              name={m.name}
              tooltip={
                m?.tooltip ? (
                  <>
                    <div className="capitalize">{tooltipSupportingText}:</div>
                    <div>{m.tooltip}</div>
                  </>
                ) : undefined
              }
            />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Markets;
